import React from 'react';
import './HomeFooter.css';

function HomeFooter() {
  return (
    <footer className="footer">
      {/* <div className="footer__top">
        <span>United States</span>
      </div> */}
      <div className="footer__bottom">
        <div className="footer__links">
          copyright © 2025 Anyworq - All rights reserved.
        </div>
        <div className="footer__links">
          <a href="/privacypolicy">Privacy</a>
          <a href="/termsandconditions">T&C</a>
          <a href="/aboutus">About</a>
          <a href="#">Advertising</a>
          <a href="#">Business</a>
          <a href="/howsearchworks">How Search works</a>
          <a href="/termsofservice">Terms of Service</a>
          <a href="/faq">FAQ</a>
          {/* <a href="#">Settings</a> */}
        </div>
      </div>
    </footer>
  );
}

export default HomeFooter;